import ReferencePayment from "../features/referencePayment/ReferencePayment";
import { emycPaymentService } from "../features/referencePayment/referencePaymentServices";

const Emyc = () => <ReferencePayment service={emycPaymentService} />;

export default Emyc;
